import React from "react";
import BlogCardComponent from "./BlogCardComponent";
import { ButtonBase } from "@reusejs/react";
import GreaterThanSvgBlog from "../../Icons/GreaterThanSvgBlog";
import { useRouter } from "next/router";

const LatestArticleComponent = (props: any) => {
  const router = useRouter();
  const cardDeta = {
    title: "Lorem Ipsum: Consectetur adipiscing elit sed do",
    description:
      "Et odit maiores ut ducimus omnis est laudantium modi et Quis vitae sed eveniet dolores hic labore ipsam vel voluptatem nulla. Et nemo repudiandae At temporibus voluptas.",
  };

  const mainHeadingClasses = `text-3xl font-extrabold ${"text-blue-900"} sm:text-3xl sm:leading-none sm:tracking-tight lg:text-4xl`;
  const subHeadingClasses = `mt-4 max-w-2xl text-base ${"text-gray-500"}`;

  return (
    <div className="pt-10  w-full bg-gray-50 pb-24">
      <div className="max-w-7xl flex-col flex mx-auto px-6 xl:px-0 overflow-hidden">
        <div className="md:flex justify-between w-full mx-auto">
          <div className="flex flex-col">
            <h2 className={mainHeadingClasses}>
              {props.heading ? props.heading : "Latest articles"}
            </h2>
            <p className={subHeadingClasses}>
              {props.description
                ? props.description
                : "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt."}
            </p>
          </div>
          <ButtonBase
            onClick={() => router.push("/blogs")}
            buttonSuffix={<GreaterThanSvgBlog />}
            label="View all posts"
            buttonBaseClasses={{
              font: "text-base items-baseline font-medium bg-transparent gap-x-3 whitespace-nowrap h-fit hover:bg-transparent",
              border: "pr-0 pl-0",
              textColor: "text-blue-600",
              alignment: "flex justify-start md:mt-14",
            }}
          />
        </div>
        <div className="flex mt-16 max-w-7xl gap-x-2 sm:gap-x-4 md:gap-x-10 overflow-x-auto scrollbar-hide">
          {props.allPosts?.map((item: any, index: any) => {
            return (
              <BlogCardComponent
                data={item.attributes}
                index={item.id}
                key={index}
                latest={true}
                image={
                  item.attributes.image?.data
                    ? item.attributes.image.data.attributes.url
                    : ""
                }
              />
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LatestArticleComponent;
